import { render, staticRenderFns } from "./captions.vue?vue&type=template&id=4d1c3608&scoped=true&"
import script from "./captions.vue?vue&type=script&lang=js&"
export * from "./captions.vue?vue&type=script&lang=js&"
import style0 from "./captions.vue?vue&type=style&index=0&id=4d1c3608&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../Retirement Planner.Admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1c3608",
  null
  
)

export default component.exports